// extracted by mini-css-extract-plugin
export var ciContainer = "CouponInputV2_ciContainer__6r6OR";
export var ciInput = "CouponInputV2_ciInput__puUUv";
export var ciInputWrapper = "CouponInputV2_ciInputWrapper__UhEvF";
export var ciInvalid = "CouponInputV2_ciInvalid__gSTnZ";
export var ciLabel = "CouponInputV2_ciLabel__RmqKb";
export var secondaryInputWrapper = "CouponInputV2_secondaryInputWrapper__cYjXD";